module.exports = __webpack_public_path__ + "img/logo.d2009e04.png";